import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import BaseButton from 'src/common/components/base-button';
import { AppState } from 'src/common/redux/configure-store';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import { ReactComponent as Barcode } from '../../item-list/media/barcode.svg';
import { codeContainerStyles } from '../../common/components/code-container/components/code-container-styles';
import { useTranslation } from 'react-i18next';

const PriceCheckScanWindow = (props: PriceCheckScanState): JSX.Element => {
  const classes = codeContainerStyles();
  const trainingModeClasses = trainingModeStyles();
  const { t } = useTranslation();
  const leftHanded = useSelector((state: AppState): boolean => state.cashierPreferences.leftHanded);
  const trainingMode = useSelector((state: AppState): boolean => state.posMode.trainingMode);

  return (
    <Grid
      item
      className={`fullHeight flexFull ${classes.outerMostContainer}`}
      data-testid='price-check'
    >
      <Grid
        item
        className={`${
          trainingMode ? trainingModeClasses.trainingModeBackground : classes.background
        } fullWidth fullHeight`}
      >
        <Grid
          container
          direction='column'
          className={`fullHeight ${classes.outerFlexDesign}`}
          data-testid='price-check-scanning-container'
        >
          <Grid
            item
            container
            className={classes.flexDesign}
            direction={leftHanded ? 'row-reverse' : 'row'}
            data-testid='price-check-body-container'
          >
            <Grid item container className={classes.containerAlignment}>
              <Typography
                className={`${classes.codeContainerTitleHeader} ${classes.codeContainerSubHeaderLabel}`}
                data-testid='price-check-body-text'
              >
                {t('Price_check_scan_heading')}
              </Typography>
              <Grid container justifyContent='center'>
                <Barcode />
              </Grid>
            </Grid>
            <Grid item container justifyContent='center' className={classes.selfAlign}>
              <BaseButton
                buttonType='white'
                onClick={props.onCancel}
                data-testid='price-check-cancel-button'
              >
                {t('Cancel')}
              </BaseButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PriceCheckScanWindow;

interface PriceCheckScanState {
  onCancel: () => void;
}
